





















import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import List from '@/components/list'
import { ListType } from '@/util/types'

import { getRecommendList } from '@/api/res'

import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import { EventEmitter } from 'events'
@Component({
  components: {
    List
  }
})
export default class CourseIndex extends ViewBase {
  listType = ListType.cloudCourse
  item: any = {}
  resList: any[] = []
  myswiper: any = ''
  created() {
    //     this.lang = this.i18n.VCourse
    //     const lang: any = this.lang
    this.fetch()
  }
  async fetch() {
    try {
      const { data } = await getRecommendList()
      this.resList = data
      this.$nextTick(() => {
        this.initSwiper()
      })

      // console.log(data)
      //       this.imgurl = data.banner
      //       this.resList = data.res_list
    } catch (ex) {
      this.handleError(ex)
    }
  }

  godetailRoute(row: any) {
    this.$router.push({
      name: 'courseDetail',
      params: {
        id: row.id + '',
        type: '0'
      }
    })

    // const { id } =
    // return {
    //   name: this.isCourse ? 'courseDetail' : 'resourceDetail',
    //   params: { id, type: this.type == 10 ? 0 : 1 }
    // }
  }
  // swiper api: https://www.swiper.com.cn/api/
  initSwiper() {
    this.myswiper = new Swiper('.swiper-container', {
      slidesPerView: 'auto',
      spaceBetween: 22,
      centeredSlides: true,
      autoplay: {
        delay: 5000, // 1秒切换一次
        disableOnInteraction: false // 用户操作过swiper后是否继续自动播放
      },
      // observer:true,
      // observeParents:true,
      grabCursor: true,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    })
  }
}
